import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  IconButton,
  Box,
  CircularProgress,
} from "@mui/material";
import "../styles.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from '@mui/icons-material/Edit';
import { networkUrls } from "../../../services/networkurls";
import { Get, Put } from "../../../services/apiServices";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Chip, Divider } from "@mui/material";
import { saveAs } from "file-saver";
import DeleteIcon from '@mui/icons-material/Delete';
import ReusableModal from "../../../components/ReusableModal/ReusableModal";
import EditPptModal from "../../../components/EditModal/EditPptModal";
import ReuseableSnackbar from "../../../components/Snackbar/Snackbar";
import EditMetaAcronymModal from "../../../components/EditModal/EditMetaAcronymModal";
import constants from "../../../utils/constants";
import jwtDecoder from "../../../utils/jwtDecoder";
const ProjectDocumentDetails= () => {
  const { id } = useParams<{ id: string }>();
  const navigate=useNavigate();
   const BaseURL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, "")
 const [document, setDocument] = useState<any>([]);
 const [loading, setLoading] = useState<boolean>(true);
 const[donwloadLoader,setDownloadLoader]=useState(false); 

  const [open, setOpen] = useState<boolean>(false);
  const[editModal,setEditModal]=useState(false);
  const[pptname,setPptname]=useState("");
  const [metaModalOpen, setMetaModalOpen] = useState(false);
  const [metaLoading, setMetaLoading] = useState(false);
   const [isShowSnackbar, setIsShowSnackbar] = useState(false);
  
    const [snackbarInfo, setSnackbarInfo] = useState({
      color: "",
      message: "",
    });
     const handleOpenDeleteModal = () => {
       setOpen(true);
     };
   
  const getSingleProjectDocument = async () => {
    try {
      const response = await Get(`${networkUrls.singleProjectDocumnet}/${id}`, true);
      if (response?.status === 200) {
        setDocument(response?.data || []);
      }
    } catch (error) {
      console.log(error, "err");
    }finally{
         setLoading(false);
    }
  };


  const updateMetadata = async (metadata: any, acronyms: any) => {
    try {
      const response = await Put(networkUrls.updateMetadata, { doc_id:id,metadata, acronyms }, true);
      if(response?.status === 200){
        setIsShowSnackbar(true);
        setSnackbarInfo({color:"success",message:"Metadata updated successfully"});
        getSingleProjectDocument(); 
      }else{
        setIsShowSnackbar(true);
        setSnackbarInfo({color:"error",message:"Failed to update metadata"});
      }
    } catch (error) {
      console.log(error, "err");
    }
  }


  useEffect(() => {
    getSingleProjectDocument();
  }, []);
 const handleOpenEditModal = (name:string) => {
  setPptname(name);
  setEditModal(true);
 }
   if (loading) {
    return (
      <Box p={4} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }
 if (!document) {
    return (
      <Box p={4}>
        <Typography color="error">Document not found.</Typography>
      </Box>
    );
  }

 const downloadFile = async (doc: any) => {
  setDownloadLoader(true);
  const jwt = await jwtDecoder();
  try {
    const res = await fetch(`${BaseURL}${networkUrls.downloadCaseStudy}/${doc.drive_file_id}`, {
      method: "GET",
      credentials: "include",
      headers: {
      "Authorization": `Bearer ${jwt}`,  // 👈 add token here
    },
    });

    if (!res.ok) throw new Error("Download failed");

    const blob = await res.blob();

    let filename = doc.filename;
    if (!filename.includes(".")) {
      const contentType = res.headers.get("Content-Type");
      if (contentType?.includes("pdf")) filename += ".pdf";
      else if (contentType?.includes("presentationml")) filename += ".pptx";
      else if (contentType?.includes("spreadsheetml")) filename += ".xlsx";
    }

    saveAs(blob, filename);
    setDownloadLoader(false);
  } catch (err) {
    console.error("Download error:", err);
    setDownloadLoader(false);
  }
};

  return (
    <Box className="project-document-container" sx={{ padding: { xs: '12px', sm: '24px' }, maxWidth: '100%', overflowX: 'hidden' }}>
      <IconButton
  onClick={() => navigate(constants.navigationUrls.adminDashboard)}
  sx={{
    backgroundColor: "#4D8FAC",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#3b7694",
    },
    mb: 2,
  }}
>
  <ArrowBackIcon />
</IconButton>
<Box className="project-document-header" sx={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:1}}>
  <Box className="project-document-title-row" sx={{display:"flex",justifyContent:"flex-start",alignItems:"center",flexWrap:"wrap",flex:1,minWidth:0}}>
    
      <Typography variant="h4" gutterBottom className="file-name" sx={{mb:0,wordBreak:"break-word",overflowWrap:"break-word",maxWidth:"100%"}}>
        {document.filename}
      </Typography>
       <IconButton onClick={()=>handleOpenEditModal(document.filename)} title="Edit Document" sx={{flexShrink:0}}>
                  <EditIcon sx={{color:"#3b7694"}}/>
                </IconButton>

  </Box>

     <IconButton  onClick={handleOpenDeleteModal} sx={{flexShrink:0}}>
      <DeleteIcon sx={{color:"red"}}/>
     </IconButton>
</Box>

      <Card sx={{ marginBottom: 3, maxWidth: '100%', overflow: 'hidden' }}>
        <CardContent sx={{ padding: { xs: '12px !important', sm: '16px !important' } }}>
          <Typography variant="h6" fontWeight="bold" paddingBottom="4px">Summary</Typography>
          <Typography variant="body1" paragraph className="summary-text" sx={{wordBreak:"break-word",overflowWrap:"break-word"}}>
            {document.summary}
          </Typography>
             <Divider /> 
          <Grid container spacing={2} sx={{paddingTop:"4px",maxWidth:"100%"}}> 
            <DetailBlock label="Industries" items={document.industries} acronyms={document.acronyms?.industries} />
            <DetailBlock label="Organizations" items={document.organizations} acronyms={document.acronyms?.organizations} />
            <DetailBlock label="Regions" items={document.regions}  acronyms={document.acronyms?.regions}/>
            <DetailBlock label="Technologies" items={document.technologies} acronyms={document.acronyms?.technologies} />
            <DetailBlock label="Document Types" items={document.document_types} acronyms={document.acronyms?.document_types} />
          </Grid>

          <Grid className="project-document-actions" container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12} sm="auto">
              <Button
                variant="contained"
                startIcon={<VisibilityIcon />}
                sx={{backgroundColor:"#4D8FAC", width: { xs: '100%', sm: 'auto' }}}
                href={document.drive_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                View
              </Button>
            </Grid>
            <Grid item xs={12} sm="auto">
              <Button
                variant="contained"
                startIcon={donwloadLoader ? <CircularProgress size={16} sx={{ color: "white" }} /> : <DownloadIcon />}
                onClick={() => downloadFile(document)}
                disabled={donwloadLoader}
                sx={{backgroundColor:"#4D8FAC", width: { xs: '100%', sm: 'auto' }}}
              >
                {donwloadLoader ? "Downloading..." : "Download"}
              </Button>
            </Grid>
            <Grid item xs={12} sm="auto">
              <Button variant="contained" onClick={() => setMetaModalOpen(true)}  startIcon={<EditIcon />}  sx={{backgroundColor:"#4D8FAC", width: { xs: '100%', sm: 'auto' }}} >
                Edit Metadata
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
       {isShowSnackbar && (
              <ReuseableSnackbar
                isShowSnackbar={isShowSnackbar}
                colour={snackbarInfo.color}
                setIsShowSnackbar={setIsShowSnackbar}
                message={snackbarInfo.message}
                autoHideDuration={2000}
              />
            )}
       {editModal && <EditPptModal open={editModal} setOpen={setEditModal} type="edit-ppt-name"  name={pptname} setIsShowSnackbar={setIsShowSnackbar} setSnackbarInfo={setSnackbarInfo} id={id}  getCall={getSingleProjectDocument}/>}
        {open && <ReusableModal open={open} setOpen={setOpen} type="delete"  name={pptname} setIsShowSnackbar={setIsShowSnackbar} setSnackbarInfo={setSnackbarInfo} id={id}  getCall={getSingleProjectDocument}/>}
      {metaModalOpen &&   <EditMetaAcronymModal
          open={metaModalOpen}
          setOpen={setMetaModalOpen}
          initialMetadata={{
            organizations: document.organizations || [],
            industries: document.industries || [],
            technologies: document.technologies || [],
            document_types: document.document_types || [],
            regions: document.regions || [], 
          }}
          initialAcronyms={document.acronyms || {
            organizations: [],
            industries: [],
            technologies: [],
            document_types: [],
            regions: [],
          }}
          loading={metaLoading}
          onSubmit={async ({ metadata, acronyms }) => {
            setMetaLoading(true);
           await updateMetadata(metadata,acronyms);
           
            setMetaLoading(false);
            setMetaModalOpen(false);
          }}
        />}
    </Box>
  );
};

interface DetailBlockProps {
  label: string;
  items: string[];
  acronyms?: string[];
}

const DetailBlock: React.FC<DetailBlockProps> = ({ label, items, acronyms }) => (
  <Grid item xs={12} sx={{maxWidth:"100%"}}>
    <Typography variant="subtitle2"  fontWeight="bold" sx={{ mb: 1 }}>{label}</Typography>
    {items && items.length > 0 ? (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2, maxWidth:"100%" }}>
        {items.map((item, i) => (
          <Chip
            key={i}
            label={
              acronyms && acronyms[i]
                ? `${item} (${acronyms[i]})`
                : item
            }
            variant="outlined"
            sx={{maxWidth:"100%"}}
          />
        ))}
      </Box>
    ) : (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        No {label.toLowerCase()} found
      </Typography>
    )}
    <Divider />
  </Grid>
);


export default ProjectDocumentDetails;
